"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _web3Utils = require("web3-utils");

var _secp256k = _interopRequireDefault(require("secp256k1"));

var _FDSSwarm = _interopRequireDefault(require("./FDS-Swarm"));

var _FDSTrace = _interopRequireDefault(require("./FDS-Trace"));

var _axios = require("axios");

var _beeJs = require("@ethersphere/bee-js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var POSTAGE_STAMP = '0000000000000000000000000000000000000000000000000000000000000000';

class SwarmFeeds {
  /**
   * Creates a new instance of SwarmFeeds
   * @constructor
   * @param {string} swarmNode - The url of the Swarm gateway endpoint.
   */
  constructor(config) {
    if (typeof config.beeGateway !== 'string') {
      throw new Error('You must provide a Swarm gateway endpoint.');
    }

    this.swarmNode = config.beeGateway;
    this.bee = new _beeJs.Bee(config.beeGateway);
  }
  /**
   * Retrieves the Swarm hash associated with pointer of a topic
   * @get
   * @param {string} address - 0x prefixed Ethereum address of the owner of the feed.
   * @param {string} topicName - utf8 string of the topic.
   * @param {any} responseType response type
   * @returns {promise} promise which resolves rejects with error based on ajax request outcome.
   */


  get(address, topicName, privateKey) {
    var _arguments = arguments,
        _this = this;

    return _asyncToGenerator(function* () {
      var responseType = _arguments.length > 3 && _arguments[3] !== undefined ? _arguments[3] : 'text';
      var withAddress = _arguments.length > 4 && _arguments[4] !== undefined ? _arguments[4] : false;

      // let pk = Buffer.from(privateKey.slice(-64), 'hex');
      // let wallet = new UnsafeWallet(pk);
      // let topic = padLeft(toHex(topicName), 64, '0');
      var topic = _this.bee.makeFeedTopic(topicName);

      var feedReader = _this.bee.makeFeedReader('sequence', topic, address);

      var download = yield feedReader.download();
      var data = yield _this.bee.downloadData(download.reference).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(function* (data) {
          if (responseType === 'text') {
            return yield data.text();
          }

          return data;
        });

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());

      if (responseType === 'text') {
        var decodedData = new TextDecoder().decode(p);

        if (withAddress) {
          return {
            value: decodedData,
            address: download.reference
          };
        } else {
          return decodedData;
        }
      }

      if (responseType === 'arraybuffer') {
        if (withAddress) {
          return {
            value: data,
            address: download.reference
          };
        } else {
          return data;
        }
      }
    })();
  }
  /**
   * Retrieves the Swarm hash associated with pointer of a topic
   * @set
   * @param {string} address - 0x prefixed Ethereum address of the owner of the feed.
   * @param {string} topicName - utf8 string of the topic.
   * @param {string} privateKey - private key of the owner of the feed.
   * @param {string} data - a text string of data which will be uploaded and the resultant hash set as the pointer location.
   * @returns {promise} promise which resolves rejects with error based on ajax request outcome.
   */


  set(address, topicName, privateKey, data) {
    var _arguments2 = arguments,
        _this2 = this;

    return _asyncToGenerator(function* () {
      var pin = _arguments2.length > 4 && _arguments2[4] !== undefined ? _arguments2[4] : false;

      var topic = _this2.bee.makeFeedTopic(topicName);

      var writer = _this2.bee.makeFeedWriter('sequence', topic, privateKey);

      var manifest = yield _this2.bee.createFeedManifest(POSTAGE_STAMP, 'sequence', topic, address);
      var encodedData = new TextEncoder().encode(data);
      var dataReference = yield _this2.bee.uploadData(POSTAGE_STAMP, encodedData);
      var upload = yield writer.upload(POSTAGE_STAMP, dataReference.reference);
      return dataReference;
    })();
  }
  /**
   * Performs XMLHTTPRequests
   * @sendRequest
   * @param {string} url - url of the request.
   * @param {string} requestType - request type, must be POST or GET.
   * @param {string} responseType - expected response type, must be text or arraybuffer
   * @param {arraybuffer} data - binary data contained in ArrayBuffer.
   * @returns {promise} promise which resolves with data or rejects with error based on ajax request outcome.
   */


  sendRequest(url, requestType, responseType) {
    var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var pinHeader = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    _FDSTrace.default.time('sendRequest//SwarmFeeds');

    if (data) {
      data = Buffer.from((0, _web3Utils.hexToBytes)(data));
    }

    var headers = {
      Accept: 'application/octet-stream'
    };
    return (0, _axios.request)({
      responseType: responseType,
      url: "".concat(this.swarmNode).concat(url),
      method: requestType,
      headers: headers,
      data: data,
      transformResponse: [function (data) {
        // Do whatever you want to transform the data
        if (responseType === 'arraybuffer') {
          return Buffer.from(data);
        } else {
          return data;
        }
      }]
    }).then(response => {
      _FDSTrace.default.timeEnd('sendRequest//SwarmFeeds');

      _FDSTrace.default.log(url, requestType);

      return response.data;
    });
  }
  /**
   * Signs data using secp256k1 curve
   * @signData
   * @param {string} data - hex encoded data.
   * @param {string} privateKey key to sign
   * @returns {string} hex encoded signature.
   */


  signData(data, privateKey) {
    var sigObj = _secp256k.default.sign(Buffer.from((0, _web3Utils.hexToBytes)(data)), Buffer.from((0, _web3Utils.hexToBytes)(privateKey)));

    return "0x".concat(sigObj.signature.toString('hex'), "0").concat(sigObj.recovery.toString());
  }

}

var _default = SwarmFeeds;
exports.default = _default;
module.exports = exports.default;